import React from 'react';
import { Page, Text, View, Document, Font, Image } from '@react-pdf/renderer';
import { ToWords } from 'to-words';
import moment from 'moment-timezone';
import { IntlShape } from 'react-intl';
import ReceiptImage from 'images/header-receipt.png';
import notoSansArabic from 'fonts/NotoSansArabic-Regular.ttf';
import RobotoBold from 'fonts/Roboto-Medium.ttf';
import RobotoRegular from 'fonts/Roboto-Regular.ttf';
import RobotoItalic from 'fonts/Roboto-Italic.ttf';
import RobotoBoldItalic from 'fonts/Roboto-BoldItalic.ttf';
import { translate } from 'containers/services/translate';
import messages from 'containers/TransactionManagerTimeLine/OfferRegulation/messages';
import { styles } from 'containers/TransactionManagerTimeLine/OfferRegulation/documents/styles';

Font.register({
  family: 'NotoSansArabic',
  src: notoSansArabic,
});
Font.register({
  family: 'Roboto',
  src: RobotoRegular,
  fontWeight: 'normal',
  fonts: [
    {
      src: RobotoBold,
      fontWeight: 'bold',
    },
    {
      src: RobotoRegular,
      fontWeight: 'normal',
    },
    {
      src: RobotoItalic,
      fontWeight: 'normal',
      fontStyle: 'italic',
    },
    {
      src: RobotoBoldItalic,
      fontWeight: 'bold',
      fontStyle: 'italic',
    },
  ],
});
export interface ReceiptDocumentProps {
  intl: IntlShape;
  body: any;
}

export const ReceiptDocument: React.FC<ReceiptDocumentProps> = (
  props,
): JSX.Element => {
  const toWords = new ToWords({
    localeCode: 'fr-FR',
  });

  return (
    <Document>
      <Page style={[styles?.page]}>
        <View style={[styles?.imageSection]}>
          <Image src={ReceiptImage} />
        </View>
        <View style={[styles?.section]}>
          <Text style={[styles?.withUnderline]}>
            {translate(messages.ReceiptDocumentTitle, props, {
              claimNumber: props.body.claimNumber,
            })}
          </Text>
        </View>
        <View style={[styles?.section]}>
          <Text>
            {translate(messages.ReceiptDocumentSubTitle, props, {
              victimName: props.body.victimName,
              victimCin: props.body.victimCin,
            })}
          </Text>
        </View>
        <View style={[styles?.section]}>
          <Text>
            {translate(messages.ReceiptDocumentParagraph1, props, {
              nextOfKin: '',
            })}
          </Text>
        </View>
        <View style={[styles?.section]}>
          <Text>
            {translate(messages.ReceiptDocumentParagraph2, props, {})}
          </Text>
        </View>
        <View style={[styles?.section]}>
          <Text>
            {translate(messages.ReceiptDocumentParagraph3, props, {
              amount: props.body.amount,
              amountLetter: toWords.convert(props.body.amount, {
                currency: true,
                currencyOptions: {
                  name: 'dirham',
                  plural: 'dirhams',
                  symbol: 'DH',
                  fractionalUnit: {
                    name: 'centime',
                    plural: 'centimes',
                    symbol: '',
                  },
                },
              }),
              lossDate: props.body.lossDate,
              driverName: props.body.driverName,
              registrationNumber: props.body.registrationNumber,
              vehcileMarque: props.body.vehcileMarque,
              suscribtionName: props.body.suscribtionName,
            })}
          </Text>
        </View>
        <View style={[styles?.section]}>
          <Text>
            {translate(messages.ReceiptDocumentParagraph4, props, {})}
          </Text>
        </View>
        <View style={[styles?.section]}>
          <Text>
            {translate(messages.ReceiptDocumentParagraph5, props, {})}
          </Text>
        </View>
        <View style={[styles?.section]}>
          <Text>
            {translate(messages.ReceiptDocumentParagraph6, props, {})}
          </Text>
        </View>
        <View style={[styles?.section]}>
          <Text>
            {translate(messages.ReceiptDocumentParagraph7, props, {
              claimNumber: props.body.claimNumber,
            })}
          </Text>
        </View>
        <View style={[styles?.section]}>
          <Text>
            {translate(messages.ReceiptDocumentParagraph8, props, {})}
          </Text>
        </View>
        <View style={[styles?.section]}>
          <Text>
            {translate(messages.ReceiptDocumentParagraph9, props, {})}
          </Text>
        </View>
        <View style={[styles?.rowColumn]}>
          <View>
            <View style={[styles?.finalsection]}>
              <Text>
                {translate(messages.ReceiptDocumentFooter2, props, {
                  date: moment().format('DD/MM/YYYY'),
                })}
              </Text>
            </View>
          </View>
          <View>
            <View style={[styles?.finalsection]}>
              <Text>
                {translate(messages.ReceiptDocumentFooter1, props, {})}
              </Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};
export default ReceiptDocument;
